import React from "react";
import Highlighter from "react-highlight-words";
import Tooltip from "react-tooltip";
import _ from "lodash";
import moment from "moment";
import I18n from "../../../i18n/I18n";
import { Button, Icon, LocaleLink } from "../../common/";
import Helper from "../../../helper/Helper";
import PicklistBox from "./picklistBox/PicklistBox";
import styles from "../../orders/orderTable/OrderTable.scss";

const ProductTable = props => {
  const {
    browser,
    data,
    searchString,
    exportPicklist,
    isExporting,
    printCall,
    isPrinting
  } = props;

  const property = Helper.validator(data);

  const rows =
    data && !_.isEmpty(data)
      ? data.map((item, index) => {
          return (
            <tr className={styles.row}>
              {property.haveVal("picklist_nr")? (
                <td>
                  <LocaleLink
                    to={`/stock-request/picklist/${item.picklist_nr}`}
                  >
                    <Button variant="dashed">
                      <Highlighter
                        highlightClassName={styles.highlight}
                        searchWords={[searchString]}
                        autoEscape={true}
                        textToHighlight={item.picklist_nr}
                      />
                    </Button>
                  </LocaleLink>
                </td>
              ) : (
                ""
              )}
              {property.haveQtyVal("qty") ? <td>{item.qty}</td> : ""}
              {property.haveVal("warehouse_code") ? <td>{item.warehouse_code}</td> : ""}
              {property.haveVal("created_at") ? (
                <td>
                  {moment(item.created_at).format(
                    `YYYY-MM-DD [${
                      Helper.getLang() === "ar" ? "" : "at"
                    }] h:mm:ss a`
                  )}
                </td>
              ) : (
                ""
              )}
              <td>
                <LocaleLink to={`/stock-request/picklist/${item.picklist_nr}`}>
                  <Button
                  // disabled={_.isEmpty(this.state.selectedItems)}
                  // variant="secondary"
                  >
                    {I18n.getText("stock-request.mark-readyforpickup")}
                  </Button>
                </LocaleLink>
              </td>
              <td>
                <span className={styles.btnWrapper}>
                  {/* First Tooltip */}
                  <Button
                    className={styles.btnCtr}
                    variant="transparent"
                    data-tip
                    data-for={"tooltip1"}
                    onClick={() => exportPicklist(item.picklist_nr)}
                  >
                    <Icon name="download" className={styles.printIcon} />
                  </Button>
                  <Tooltip
                    className={styles.tooltip}
                    place="left"
                    type="dark"
                    effect="solid"
                    id={"tooltip1"}
                  >
                    <span>
                      {I18n.getText("statement.tooltip-export", {}, "Export")}
                    </span>
                  </Tooltip>

                  {/* Second tooltip */}
                  <a target="_blank" data-tip data-for={"tooltip2"}>
                    <Button
                      className={styles.btnCtr}
                      variant="transparent"
                      onClick={() => printCall(item.picklist_nr)}
                    >
                      <Icon name="print" className={styles.printIcon} />
                    </Button>
                  </a>
                  <Tooltip
                    className={styles.tooltip}
                    place="left"
                    type="dark"
                    effect="solid"
                    id={"tooltip2"}
                  >
                    <span>
                      {I18n.getText("statement.tooltip-print", {}, "Print")}
                    </span>
                  </Tooltip>
                </span>
              </td>
            </tr>
          );
        })
      : "";

  const box =
    data && !_.isEmpty(data)
      ? data.map((item, index) => (
          <div>
            <PicklistBox
              item={item}
              searchString={searchString}
              exportPicklist={exportPicklist}
              isExporting={isExporting}
              printCall={printCall}
              isPrinting={isPrinting}
            />
          </div>
        ))
      : "";

  return (
    <div className={styles.ctr}>
      {browser && browser.greaterThan.tablet ? (
        <table className={styles.table}>
          <thead>
            <tr className={`${styles.row} ${styles.head}`}>
              {property.haveVal("picklist_nr") ? (
                <th>{I18n.getText("stock-request.picklist-nr")}</th>
              ) : (
                ""
              )}
              {property.haveQtyVal("qty") ? <th>{I18n.getText("variants.qty")}</th> : ""}
              {property.haveVal("warehouse_code") ? (
                <th>{I18n.getText("offer.warehouse-code")}</th>
              ) : (
                ""
              )}
              {property.haveVal("created_at") ? (
                <th>{I18n.getText("statement-details.order-view-created")}</th>
              ) : (
                ""
              )}
              <th />
              <th />
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>
      ) : (
        box
      )}
    </div>
  );
};

export default ProductTable;



// WEBPACK FOOTER //
// ./src/components/stockRequest/picklistTable/PicklistTable.js